/**
 * External link detector
 *
 * @param {boolean} [enableDebug=false] - Enable debugging output
 */
export default (enableDebug = false) => {
  const debug = enableDebug;

  function isExternal(url) {
    try {
      return new URL(url).hostname !== window.location.hostname;
    } catch {
      return false;
    }
  }

  function detect_links() {
    const links = document.querySelectorAll('a');

    links.forEach((link) => {
      if (
        link.href &&
        isExternal(link.href) &&
        !link.classList.contains('whitelist-domain-link')
      ) {
        link.classList.add('external');
        if (debug) console.log('Added external class to:', link.href);
      }
    });
  }

  function inject_icon() {
    const externalLinks = document.querySelectorAll(
      'a.blacklist-domain-link:not(.social-menu__link)',
    );
    const svgCode =
      '<svg class="external-icon" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.28571 12.5C0.932143 12.5 0.629464 12.3741 0.377678 12.1223C0.125893 11.8705 0 11.5679 0 11.2143V1.78571C0 1.43214 0.125893 1.12946 0.377678 0.877679C0.629464 0.625893 0.932143 0.5 1.28571 0.5H6V1.78571H1.28571V11.2143H10.7143V6.5H12V11.2143C12 11.5679 11.8741 11.8705 11.6223 12.1223C11.3705 12.3741 11.0679 12.5 10.7143 12.5H1.28571ZM5.91071 7.48214L5 6.57143L9.80357 1.78571H7.71429V0.5H12V4.78571H10.7143V2.69643L5.91071 7.48214Z" fill="#6049E9"/></svg>';

    externalLinks.forEach(function (element) {
      if (debug) console.log('Injected an external link icon');
      element.innerHTML += svgCode;
    });
  }

  detect_links();
  inject_icon();
};
